import Products_A_0 from './Products_A/Products_A_0'
import Products_A_1 from './Products_A/Products_A_1'
import Products_A_2 from './Products_A/Products_A_2'
import Products_A_3 from './Products_A/Products_A_3'
import Products_A_4 from './Products_A/Products_A_4'
import Products_A_5 from './Products_A/Products_A_5'
import Products_A_6 from './Products_A/Products_A_6'
import Products_A_7 from './Products_A/Products_A_7'
import Products_A_8 from './Products_A/Products_A_8'

const Products_A = [
  Products_A_0,
  Products_A_1,
  Products_A_2,
  Products_A_3,
  Products_A_4,
  Products_A_5,
  Products_A_6,
  Products_A_7,
  Products_A_8,
  null,
  null,
  null
]
export default Products_A



// WEBPACK FOOTER //
// ./src/components/Products_A.js